<template>
  <div>
    <div v-if="viewDetail">
      <h6>Message service</h6>
      
      
      <div
        style="border-radius: 5px; background-color: #eef4f9; padding: 20px"
        v-if="dataContent.length != 0"
      >
        <h6 class="mt-0 mb-0">No : {{ dataContent[0].id }}</h6>
        <p class="mt-0 mb-0 text-dark">
          <strong>Toppic : {{ dataContent[0].topic }}</strong>
        </p>
      </div>
      <a-list
        class="comment-list"
        size="small"
        :header="`${dataMsg.length} replies`"
        item-layout="horizontal"
        :data-source="dataMsg"
      >
        <a-list-item slot="renderItem" slot-scope="item, index">
          <a-comment
            :author="
              item.user === dataContent[0].onwercase
                ? dataContent[0].onwercase
                : item.user
            "
          >
            <template slot="avatar">
              <a-avatar shape="square" :size="32" icon="user" />
            </template>
            <template slot="actions">
              <span
                v-if="item.upload_file !== null && item.upload_file !== 'null'"
                >File : <a :href="`https://my.muic.io/media/ticket_file/${item.upload_file.split('/media/ticket_file/')[1]}`" target="_blank">https://my.muic.io/media/ticket_file/{{ item.upload_file.split('/media/ticket_file/')[1] }}</a> 
              </span
              >
            </template>
            <p slot="content">
              <span v-html="item.message"></span>
            </p>
            <a-tooltip
              slot="datetime"
              :title="moment(item.created_at).format('DD/MM/YYYY , LT')"
            >
              <span>{{
                moment(item.created_at).format("DD/MM/YYYY , LT")
              }}</span>
            </a-tooltip>
          </a-comment>
        </a-list-item>
      </a-list>
      <!-- dataContent[0].status -->
      <!-- status : wait -->
      <panel-wait
        v-if="dataContent[0].status === 'wait'"
        :dataWait="{ id: dataContent[0].id }"
        @addNewComment="addNewComment"
      />
      <!-- status : accept -->
      <panel-accept
        v-if="dataContent[0].status === 'accept'"
        :dataAccept="{ id: dataContent[0].id }"
        @changeStatusTicket="changeStatusTicket"
        @addNewComment="addNewComment"
      />
      <!-- status : success -->
      <panel-success
        v-if="dataContent[0].status === 'success'"
        :dataSuccess="{
          id: dataContent[0].id,
          ticketpoint: dataContent[0].ticketpoint,
        }"
      />
    </div>
    <div v-else>
      
      
    </div>
  </div>
</template>

<script>
import panelWait from "./status/panel_wait.vue";
import panelAccept from "./status/panel_accept.vue";
import panelSuccess from "./status/panel_success.vue";
export default {
  components: {
    panelWait,
    panelAccept,
    panelSuccess,
  },
  props: {
    viewDetail: {
      type: Boolean,
      default: () => false,
    },
    dataContent: {
      type: Array,
      default: () => [],
    },
    dataMsg: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    addNewComment(...args) {
      this.$emit("updateComment", args[0]);
    },
    changeStatusTicket(...args) {
      this.$emit("updateTicket", args[0]);
    },
  },
};
</script>